import React from 'react';
import styled from 'styled-components';

import breakpoints from '../../util/breakpoints';
import FadeInImg from '../FadeInImg';
import {
  DribbbleLink,
  LinkedinLink,
  GithubLink,
} from './SocialLink';

const Bio = styled.div`
  display: grid;
  grid-template-areas:
    "image header"
    "image subtitle"
    "image links";
  grid-template-columns: 100px 1fr;
  grid-template-rows: 52px 25px 1fr;
  padding-top: 50px;
  will-change: transform;

  ${breakpoints.lg`
    grid-template-columns: 125px 1fr;
    grid-template-rows: 64px 40px 1fr;
  `}

  ${breakpoints.xl`
    grid-template-columns: 175px 1fr;
    grid-template-rows: 64px 40px 1fr;
  `}
`;

const ImgWrapper = styled.div`
  grid-area: image;
  align-self: center;
  width: 100px;
  height: 100px;
  border-radius: 50px;
  overflow: hidden;
  border: 4px solid #94a0b7;

  ${breakpoints.lg`
    width: 125px;
    height: 125px;
    border-radius: 63px;
  `}

  ${breakpoints.xl`
    align-self: top;
    width: 175px;
    height: 175px;
    border-radius: 87px;
  `}
`;

const Header = styled.h2`
  grid-area: header;
  color: white;
  font-size: 2em;
  font-weight: 700;
  padding: 10px 0 0 20px;
  margin-bottom: 0;

  ${breakpoints.lg`
    font-size: 2.2em;
  `}

  ${breakpoints.xl`
    font-size: 2.5em;
  `}
`;

const Subtitle = styled.p`
  grid-area: subtitle;
  color: white;
  font-size: 1em;
  padding-left: 22px;
  font-weight: 700;
  margin: 0;
  color: #94a0b7;

  ${breakpoints.lg`
    font-size: 1.1em;
  `}

  ${breakpoints.xl`
    font-size: 1.2em;
  `}
`;

const Links = styled.div`
  padding-left: 10px;
  grid-area: links;

  > div {
    margin-left: 10px;
  }
`;

export const KatyBio = () => (
  <Bio>
    <ImgWrapper>
      <FadeInImg src="/images/katy-headshot.jpg" />
    </ImgWrapper>
    <Header>katy jeremko</Header>
    <Subtitle>Creative technology expert.</Subtitle>
    <Links>
      <DribbbleLink href="https://dribbble.com/KatyJeremko" target="_blank">dribble</DribbbleLink>
      <LinkedinLink href="https://www.linkedin.com/in/katy-jeremko-0a819a22" target="_blank">linked in</LinkedinLink>
    </Links>
  </Bio>
);

export const NicoBio = () => (
  <Bio>
    <ImgWrapper>
      <FadeInImg src="/images/nico-headshot.jpg" />
    </ImgWrapper>
    <Header>nico valencia</Header>
    <Subtitle>Internet technology expert.</Subtitle>
    <Links>
      <GithubLink href="https://github.com/nicovalencia" target="_blank">github</GithubLink>
      <LinkedinLink href="https://www.linkedin.com/in/nicovalencia/" target="_blank">linked in</LinkedinLink>
    </Links>
  </Bio>
);

export default Bio;



// WEBPACK FOOTER //
// ./src/components/ui/Bio.js